import React from 'react';
import SafeHTMLRender from '../../app/shared/SafeHTMLRender';
import { PassportNonce } from '../../lib/constants';
import './Checkbox.scss';

export type CheckboxProps = {
  id?: string;
  label: string;
  value: boolean;
  error?: string | boolean;
  onChange(e: React.FormEvent<HTMLInputElement>): void;
  onBlur?(e: React.FormEvent<HTMLInputElement>): void;
  ariaInvalid?: boolean;
  describedById?: string;
};

export const Checkbox: React.FunctionComponent<CheckboxProps> = (props: CheckboxProps): JSX.Element => {
  const {
    id,
    onChange,
    error,
    value = false,
    onBlur,
    label,
    ariaInvalid,
    describedById,
  } = props;

  const checkboxClassName = `
    registration-checkbox text-sm border py-2 px-3 mt-3 leading-tight
    ${error ? ' border-red-600' : ''}
  `;

  return (
    <>
      <div className='flex items-baseline'>
        <span>
          <input
            type='checkbox'
            id={id}
            className={checkboxClassName}
            onChange={onChange}
            onBlur={onBlur}
            checked={value}
            aria-invalid={ariaInvalid}
            aria-describedby={describedById}
          />
        </span>
        <label htmlFor={id}>
          <SafeHTMLRender nonce={PassportNonce.RICH_TEXT} html={label} className='ml-1 text-sm'/>
        </label>
      </div>
      {error && (typeof error === 'boolean') && <span className='text-red-600 text-xs py-4'>{error}</span>}
    </>
  );
};

export default Checkbox;
